// extracted by mini-css-extract-plugin
module.exports = {"container":"b2b-video-carousel-quote_container__WR75a","content":"b2b-video-carousel-quote_content__kcwLw","author":"b2b-video-carousel-quote_author___D85R"};